<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <custom-select
          :options="genderlist"
          v-model="filter.genderid"
          @input="changeGender"
          :placeholder="$t('choose')"
          :label="$t('gender')"
        >
        </custom-select>
      </b-col>
      <b-col>
        <custom-select
          :options="agecategorylist"
          v-model="filter.agecategoryid"
          @input="changeAgeCategory"
          :placeholder="$t('choose')"
          :label="$t('agecategory')"
        >
        </custom-select>
      </b-col>
      <b-col>
        <custom-select
          :options="sporttypecategorylist"
          v-model="filter.sporttypecategoryid"
          @input="changeSportTypeCategory"
          :placeholder="$t('choose')"
          :label="$t('sporttypecategory')"
        >
        </custom-select>
      </b-col>
      <b-col>
        <custom-select
          :options="sporttypelist"
          @input="Refresh"
          v-model="filter.sporttypeid"
          :placeholder="$t('choose')"
          :label="$t('sporttype1')"
        >
        </custom-select>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col>
        <b-table
          :fields="fields"
          :items="List"
          small="small"
          selectable
          @row-dblclicked="DbClick"
          @row-selected="SelectedItem"
          :select-mode="selectMode"
          responsive="sm"
          ref="selectableTable"
          show-empty
          :busy="isBusy"
          :empty-text="$t('NotFound')"
          sticky-header="60vh"
          no-border-collapse
          bordered
        >
          <template v-slot:cell(index)="{ index }">{{ index + 1 }}</template>
        </b-table>
        <div class="my-3 justify-content-between d-flex align-items-center">
          <span></span>
          <b-pagination
            v-model="filter.PageNumber"
            :total-rows="filter.totalRows"
            :per-page="filter.PageLimit"
          ></b-pagination>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>
    
    <script>
import CoachAssignmentService from ".../../../src/services/coachassignment.service";
import SportTypeService from "../../../services/sporttype.service";
import SportTypeCategoryService from "../../../services/sporttypecategory.service";
import AgeCategoryService from "../../../services/agecategory.service";
import HelperService from "../../../services/helper.service";
import CustomSelect from "../../../views/components/CustomSelect.vue";
export default {
  components: {
    CustomSelect,
  },
  props: {
    List: {
      type: Array,
      default: [],
    },
    coachassignmentid: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      sporttypelist: [],
      sporttypecategorylist: [],
      agecategorylist: [],
      genderlist: [],
      lang: localStorage.getItem("locale") || "uz_latn",
      selectMode: "single",
      filter: {
        genderid: "",
        agecategoryid: "",
        sporttypecategoryid: "",
        sporttypeid: "",
        Search: "",
        SortColumn: "",
        OrderType: "asc",
        PageNumber: 1,
        PageLimit: 400,
        pageOptions: [5, 10, 15, 20, 25, 50, 100],
        SortIcon: "arrow-up",
        totalRows: 0,
      },
      selected: [],
      isBusy: false,
      fields: [
        {
          key: "index",
          label: this.$t("index"),
          thClass: "text-center",
          tdClass: "text-left",
          sortable: false,
        },
        {
          key: "gendername",
          label: this.$t("gender"),
          thClass: "text-center",
          tdClass: "text-left",
          sortable: false,
        },
        {
          key: "agecategoryname",
          label: this.$t("agecategory"),
          thClass: "text-center",
          tdClass: "text-left",
          sortable: false,
        },
        {
          key: "sporttypecategoryname",
          label: this.$t("sporttypecategory"),
          thClass: "text-center",
          tdClass: "text-left",
          sortable: false,
        },
        {
          key: "sporttypename",
          label: this.$t("sporttype1"),
          thClass: "text-center",
          tdClass: "text-left",
          sortable: false,
        },
        {
          key: "groupname",
          label: this.$t("group"),
          thClass: "text-center",
          tdClass: "text-left",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    firstNumber() {
      return this.filter.totalRows > 0
        ? (this.filter.PageNumber - 1) * this.filter.PageLimit + 1
        : 0;
    },
    lastNumber() {
      if (this.filter.totalRows < this.filter.PageLimit) {
        return this.filter.totalRows;
      } else {
        if (
          this.filter.PageNumber * this.filter.PageLimit >
          this.filter.totalRows
        ) {
          return this.filter.totalRows;
        } else {
          return this.filter.PageNumber * this.filter.PageLimit;
        }
      }
    },
  },
  created() {
    HelperService.GetGenderList(this.lang).then((res) => {
      this.genderlist = res.data;
    });
    this.Refresh();
  },
  methods: {
    Refresh() {
      this.isBusy = true;
      CoachAssignmentService.GetCoachAssignmentTableList(
        this.coachassignmentid,
        this.filter.genderid,
        this.filter.agecategoryid,
        this.filter.sporttypecategoryid,
        this.filter.sporttypeid,
        this.filter.Search,
        this.filter.SortColumn,
        this.filter.OrderType,
        this.filter.PageNumber,
        this.filter.PageLimit
      ).then((res) => {
        this.isBusy = false;
        this.List = res.data.rows;
        this.filter.totalRows = res.data.total;
      }).catch((error) => {
            this.makeToast(error.response.data.error, "error");
          });
    },
    changeGender() {
      if (!!this.filter.genderid) {
        AgeCategoryService.GetAll(this.lang, this.filter.genderid)
          .then((res1) => {
            this.agecategorylist = res1.data;
          })
          .catch((error) => {
            this.makeToast(error.response.data.error, "error");
          });
      }
      this.filter.agecategoryid = 0;
      this.filter.sporttypecategoryid = 0;
      this.filter.sporttypeid = 0;
      this.Refresh();
    },
    changeSportTypeCategory() {
      this.filter.sporttypeid = 0;
      this.Refresh();
      this.SportType();
    },
    makeToast(message, type) {
      this.$toast.open({
        message: message,
        type: type,
        duration: 5000,
        dismissible: true,
      });
    },

    changeAgeCategory() {
      if (!!this.filter.agecategoryid) {
        SportTypeCategoryService.GetAll(this.lang, this.filter.agecategoryid)
          .then((res1) => {
            this.sporttypecategorylist = res1.data;
          })
          .catch((error) => {
            this.makeToast(error.response.data.error, "error");
          });
      }
      // this.FormGroup.agecategoryid = 0;
      this.filter.sporttypecategoryid = 0;
      this.filter.sporttypeid = 0;
      this.Refresh();
    },
    SportType() {
      SportTypeService.GetAll(
        this.lang,
        "",
        this.filter.genderid,
        this.filter.agecategoryid,
        this.filter.sporttypecategoryid
      ).then((res) => {
        this.sporttypelist = res.data;
      });
    },
    handleSort(key, active) {},
    SelectedItem(items) {
      this.selected = items;
      this.$emit("SelectedItem", this.selected[0]);
    },
    DbClick(item) {
      this.$emit("DblClick", item);
    },
  },
  watch: {
    "filter.PageNumber": {
      handler(newValue, oldValue) {
        this.Refresh();
      },
    },
  },
};
</script>
    
    <style>
</style>